// src/data/questionBank.js - Business Research Starter Questions

export const businessQuestions = [
  // Market Analysis Questions
  {
    id: 1,
    question: "Research the electric vehicle market",
    category: "Market Analysis",
    icon: "⚡",
    description: "Analyze EV market size, growth trends, and key players"
  },
  {
    id: 2,
    question: "Analyze the pet food industry trends",
    category: "Market Analysis", 
    icon: "🐕",
    description: "Study pet food market dynamics and consumer behavior"
  },
  {
    id: 3,
    question: "Study the fintech startup landscape",
    category: "Market Analysis",
    icon: "💳",
    description: "Explore fintech innovation and market opportunities"
  },
  {
    id: 4,
    question: "Compare renewable energy technologies",
    category: "Market Analysis",
    icon: "🌱",
    description: "Evaluate solar, wind, and other renewable energy sectors"
  },
  {
    id: 5,
    question: "Research the AI and machine learning market",
    category: "Technology",
    icon: "🤖",
    description: "Analyze artificial intelligence market trends and applications"
  },

  // Industry Deep Dives
  {
    id: 6,
    question: "Analyze the healthcare technology sector",
    category: "Healthcare",
    icon: "🏥",
    description: "Study digital health, telemedicine, and medical devices"
  },
  {
    id: 7,
    question: "Research the e-commerce and retail landscape",
    category: "Retail",
    icon: "🛒",
    description: "Examine online retail trends and consumer behavior"
  },
  {
    id: 8,
    question: "Study the cloud computing industry",
    category: "Technology",
    icon: "☁️",
    description: "Analyze cloud services, SaaS, and infrastructure trends"
  },
  {
    id: 9,
    question: "Explore the cybersecurity market",
    category: "Technology",
    icon: "🔒",
    description: "Research cybersecurity threats, solutions, and market growth"
  },
  {
    id: 10,
    question: "Analyze the food delivery and meal kit industry",
    category: "Food & Beverage",
    icon: "🍕",
    description: "Study food delivery platforms and changing dining habits"
  },

  // Emerging Markets & Trends
  {
    id: 11,
    question: "Research the cryptocurrency and blockchain market",
    category: "Finance",
    icon: "₿",
    description: "Analyze digital currencies, DeFi, and blockchain adoption"
  },
  {
    id: 12,
    question: "Study the remote work technology sector",
    category: "Technology",
    icon: "💻",
    description: "Explore tools and platforms enabling remote collaboration"
  },
  {
    id: 13,
    question: "Analyze the sustainable fashion industry",
    category: "Fashion & Retail",
    icon: "👕",
    description: "Research eco-friendly fashion brands and consumer trends"
  },
  {
    id: 14,
    question: "Research the mental health and wellness market",
    category: "Healthcare",
    icon: "🧠",
    description: "Study mental health apps, therapy platforms, and wellness trends"
  },
  {
    id: 15,
    question: "Explore the gaming and esports industry",
    category: "Entertainment",
    icon: "🎮",
    description: "Analyze gaming market growth, esports, and streaming platforms"
  },

  // Real Estate & Construction
  {
    id: 16,
    question: "Study the proptech and real estate technology market",
    category: "Real Estate",
    icon: "🏠",
    description: "Research property technology innovations and smart buildings"
  },
  {
    id: 17,
    question: "Analyze the construction technology sector",
    category: "Construction",
    icon: "🏗️",
    description: "Explore construction automation, materials, and project management"
  },

  // Transportation & Logistics
  {
    id: 18,
    question: "Research the autonomous vehicle industry",
    category: "Transportation",
    icon: "🚗",
    description: "Study self-driving car technology and market adoption"
  },
  {
    id: 19,
    question: "Analyze the logistics and supply chain technology market",
    category: "Logistics",
    icon: "📦",
    description: "Explore warehouse automation and supply chain optimization"
  },
  {
    id: 20,
    question: "Study the drone and UAV industry",
    category: "Technology",
    icon: "🚁",
    description: "Research commercial drone applications and market growth"
  },

  // Energy & Environment
  {
    id: 21,
    question: "Research the energy storage and battery market",
    category: "Energy",
    icon: "⚡",
    description: "Analyze battery technology and energy storage solutions"
  },
  {
    id: 22,
    question: "Analyze the water technology and treatment industry",
    category: "Environment",
    icon: "💧",
    description: "Study water purification, desalination, and conservation tech"
  },
  {
    id: 23,
    question: "Explore the carbon capture and climate tech market",
    category: "Environment",
    icon: "🌍",
    description: "Research climate solutions and carbon reduction technologies"
  },

  // Education & Learning
  {
    id: 24,
    question: "Study the edtech and online learning industry",
    category: "Education",
    icon: "📚",
    description: "Analyze educational technology and digital learning platforms"
  },
  {
    id: 25,
    question: "Research the corporate training and upskilling market",
    category: "Education",
    icon: "🎓",
    description: "Study professional development and workforce training trends"
  },

  // Agriculture & Food
  {
    id: 26,
    question: "Analyze the agtech and precision farming industry",
    category: "Agriculture",
    icon: "🌾",
    description: "Explore agricultural technology and sustainable farming solutions"
  },
  {
    id: 27,
    question: "Research the alternative protein and plant-based food market",
    category: "Food & Beverage",
    icon: "🌱",
    description: "Study meat alternatives, plant-based foods, and lab-grown proteins"
  },

  // Advanced Technology
  {
    id: 28,
    question: "Study the quantum computing industry",
    category: "Technology",
    icon: "⚛️",
    description: "Research quantum computing applications and market potential"
  },
  {
    id: 29,
    question: "Analyze the Internet of Things (IoT) market",
    category: "Technology",
    icon: "📡",
    description: "Explore connected devices, smart cities, and IoT applications"
  },
  {
    id: 30,
    question: "Research the space technology and satellite industry",
    category: "Aerospace",
    icon: "🚀",
    description: "Study commercial space ventures, satellites, and space tourism"
  }
];

export const methodologyQuestions = [
  {
    id: 'methodology_1',
    question: "How do I evaluate source credibility?",
    category: "Research Methods",
    icon: "🔍",
    description: "Learn about assessing authority, accuracy, and bias"
  },
  {
    id: 'methodology_2',
    question: "What's the difference between primary and secondary sources?",
    category: "Research Methods",
    icon: "📚",
    description: "Understand when to use each type"
  },
  {
    id: 'methodology_3',
    question: "How do I construct an effective search strategy?",
    category: "Research Methods",
    icon: "🎯",
    description: "Learn Boolean operators and keyword selection"
  }
];

// Utility functions for question management
export const getRandomQuestions = (count = 4) => {
  const shuffled = [...businessQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export const getQuestionsByCategory = (category) => {
  return businessQuestions.filter(q => q.category === category);
};

export const getAllCategories = () => {
  const categories = [...new Set(businessQuestions.map(q => q.category))];
  return categories.sort();
};

export const getQuestionById = (id) => {
  return businessQuestions.find(q => q.id === id);
};

// Default export for easy importing
export default businessQuestions;

